import { render, staticRenderFns } from "./productData.vue?vue&type=template&id=20537e73&scoped=true"
import script from "./productData.vue?vue&type=script&lang=js"
export * from "./productData.vue?vue&type=script&lang=js"
import style0 from "./productData.vue?vue&type=style&index=0&id=20537e73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20537e73",
  null
  
)

export default component.exports